export default __webpack_public_path__ + "static/media/download.49d143f5.svg";